import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  block: {
    width: '100%',
  },
}))
